import { PartnerProfile } from 'types/state';

export const createPartnerProfile = (): PartnerProfile => ({
  avatarURL: null,
  firstName: '',
  middleName: '',
  lastName: '',
  phone: '',
  country: '',
  city: '',
  details: '',
});

export const createPartnerProfileMock = (
  avatarURL?: string
): PartnerProfile => ({
  avatarURL: avatarURL || null,
  firstName: 'Полное',
  middleName: 'Имя',
  lastName: 'Партнера',
  phone: '+375 33 555-66-44',
  country: null,
  city: '',
  details: 'Я партнер с 10-летним опытом партнерства',
});
